import React, { useState, useEffect } from "react";
import { BatchNotificationWizard } from "../BatchNotification/BatchNotificationWizard/BatchNotificationWizard";
import { Icon, Tooltip } from "@material-ui/core";
import "./BatchMessageConfiguration.css";
import { ButtonPrimary } from "../../common/sharedStyle";
import { useGetComponentStringsContext } from "../../hooks/useGetComponentStrings";

export const BatchMessageConfiguration = (props: any) => {
	const { match, location, history } = props;
	const [rowKey, setRowKey] = useState("");
	const [partitionKey, setPartitionKey] = useState("");
	const [requestFromPath, setRequestFromPath] = useState("");
	const sharedStrings = useGetComponentStringsContext().Shared;

	useEffect(() => {
		setRowKey(match.params.rowKey ? match.params.rowKey : "");
		setPartitionKey(match.params.partitionKey ? match.params.partitionKey : "");
		setRequestFromPath(
			location.state && location.state.requestFromPath
				? location.state.requestFromPath
				: ""
		);
	}, [location.state, match.params.partitionKey, match.params.rowKey]);

	const backToTemplateList = () => {
		history.push({
			pathname: "/" + requestFromPath,
		});
	};

	return (
		<>
			{requestFromPath && (
				<span className="backToListBtnDiv">
					<Tooltip title={sharedStrings.backToListBtnTooltip}>
						<ButtonPrimary
							data-testid="backToListBtn"
							onClick={() => {
								backToTemplateList();
							}}
							className="backToListBtn"
							color="primary"
							variant="contained"
						>
							<Icon fontSize="small" className="backBtnIcon">
								arrow_back_ios
							</Icon>
						</ButtonPrimary>
					</Tooltip>
				</span>
			)}
			<BatchNotificationWizard
				rowKey={rowKey}
				partitionKey={partitionKey}
				backToTemplateList={requestFromPath ? backToTemplateList : () => {}}
			/>
		</>
	);
};
